import { useQuery } from '@tanstack/react-query';
import { GlobalSettingsClient } from '../api/api-global-settings';
import useApi from './api-hook';

const useClientGlobalSettings = () => {
  const api = useApi(GlobalSettingsClient);
  return useQuery({
    queryKey: ['client-global-settings'],
    queryFn: () => api.get(api.tokenSource?.token),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    retry: 1,
  });
};

export default useClientGlobalSettings;
